export const donationStatus = {
  succeeded: 'succeeded',
  pending: 'pending',
  failure: 'failure',
  refunded: 'refunded',
};

export const donationStatusLabels = {
  succeeded: 'Success',
  pending: 'Pending',
  failure: 'Failure',
  refunded: 'Refunded',
};

export const donationTypes = {
  oneTime: 'one-time',
  recurring: 'recurring',
};

export const donationTypeLabels = {
  'one-time': 'One-Time',
  recurring: 'Recurring',
};

export const donationBillingIntervalLabels = {
  month: 'Monthly',
  year: 'Annual',
};

export const reportStatus = {
  draft: 'draft',
  scheduled: 'scheduled',
  sending: 'sending',
  sent: 'sent',
  stage0: 'stage0',
  stage1: 'stage1',
  stage2: 'stage2',
  stage3: 'stage3',
};

export const reportStatusLabels = {
  draft: 'Draft',
  scheduled: 'Scheduled',
  sending: 'Ongoing',
  sent: 'Completed',
  stage0: 'Stage 1',
  stage1: 'Stage 2',
  stage2: 'Stage 3',
  stage3: 'Completed',
};

export const reportTypes = {
  single: 'single',
  abTest: 'abTest',
  recurring: 'recurring',
  socialMedia: 'socialMedia',
};

export const reportTypesLabels = {
  single: 'Single',
  abTest: 'A/B Test',
};

export const campaignSendStatus = {
  draft: 'draft',
  scheduled: 'scheduled',
  sending: 'sending',
  sent: 'sent',
  error: 'error',
};

export const campaignSendStatusLabels = {
  draft: 'Draft',
  scheduled: 'Scheduled',
  sending: 'Ongoing',
  sent: 'Complete',
  error: 'Error',
};

export const campaignType = {
  single: 'single',
  abTest: 'abTest',
  polling: 'polling',
  fundraising: 'fundraising',
  socialMedia: 'socialMedia',
};

export const campaignTypeLabels = {
  single: 'Campaign',
  abTest: 'A/B Test',
  polling: 'Polling',
  fundraising: 'Fundraising',
  socialMedia: 'Post',
};

export const campaignSortBy = {
  sendStatus: 'sendStatus',
  updatedAt: 'updatedAt',
  name: 'name',
};

export const campaignSortByLabels = {
  sendStatus: 'Stage',
  updatedAt: 'Last Edited',
  name: 'Name',
};

export const sortDirections = {
  asc: 'asc',
  desc: 'desc',
};

export const reportSortBy = {
  createdAt: 'createdAt',
  click: 'click',
  donations: 'donations',
  amountRaised: 'amountRaised',
};

export const recurringReportSortBy = {
  sendAt: 'sendAt',
  interaction: 'interaction',
  totalContacts: 'totalContacts',
};

export const templateTypes = {
  recurring: 'recurring',
  single: 'single',
  section: 'section',
};

// Welcome series are recurring templates. The first series occupies template
// orders 0-3 (4 emails); the second welcome series occupies orders 4-8 (5 emails).
export const WELCOME_SERIES = {
  first: { count: 4, startOrder: 0, endOrder: 3 },
  second: { count: 5, startOrder: 4, endOrder: 8 },
};

export const SECOND_SERIES_NAME_SUFFIX = ' - Series 2';

export const formStoreTargets = {
  campaign: 'campaign',
  template: 'template',
};

export const PREVIEW_HTML_KEY = 'ds-preview-html';

export const DEBOUNCE_DELAY_TIME_MS = 500;

export const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const TAX_ID_REGEX = /^\d{2}-?\d{7}$/;

export const CONTACT_FIELDS = [
  'email',
  'first_name',
  'last_name',
  'address_line_1',
  'address_line_2',
  'city',
  'state_province_region',
  'country',
  'postal_code',
  'phone_number',
];

export const SEGMENT_CONDITIONS = [
  'is',
  'is not',
  'contains',
  'does not contain',
  'starts with',
  'ends with',
  'is greater than',
  'is less than',
];

export const SEGMENT_MATCH_VALUES = ['any', 'all'];

export const MAP_DATA_TYPE_INPUT_TYPE = {
  string: 'text',
  number: 'number',
  date: 'date',
  boolean: 'checkbox',
};

export const CAMPAIGN_ACTIONS = {
  edit: 'Edit',
  view: 'View',
  viewReport: 'View Report',
  duplicate: 'Duplicate',
  delete: 'Delete',
  cancel: 'Cancel',
  restore: 'Restore',
};

export const SEGMENT_ACTIONS = {
  createCampaign: 'Create Campaign',
  view: 'View',
  rename: 'Rename',
  edit: 'Edit',
  delete: 'Delete',
};

export const TAG_ACTIONS = {
  createCampaign: 'Create Campaign',
  view: 'View',
  // 'Edit tag' rather than 'Rename' (the form now also edits the description, and
  // for a reserved tag the description is the ONLY editable field) and rather than
  // a bare 'Edit', which would collide with CAMPAIGN_ACTIONS.edit /
  // SEGMENT_ACTIONS.edit — these labels double as switch keys in RowActions, so a
  // duplicate value makes one branch unreachable and picks up the wrong icon.
  rename: 'Edit tag',
  delete: 'Delete',
};

export const IMPORT_JOB_ACTIONS = {
  view: 'View',
  downloadInvalid: 'Download Import Errors',
};

export const REPORT_ACTIONS = {
  viewCampaign: 'View Campaign',
  viewDonations: 'View Donations',
};

export const DASHBOARD_ACTIVE_CHART = {
  donations_usd: 'donations_usd',
  donations_number: 'donations_number',
  emails_sent: 'emails_sent',
};

export const PRIMARY_BASE_COLOR = '#1151A5';

export const ACTIVE_CHART_LABEL_MAP = {
  donations_usd: 'Donations, USD',
  donations_number: 'Donations, #',
  emails_sent: 'Emails Sent',
};

export const IMPORT_JOB_STATUS = {
  notStarted: 'NOT_STARTED',
  validating: 'VALIDATING',
  validated: 'VALIDATED',
  processing: 'PROCESSING',
  done: 'DONE',
  failed: 'FAILED',
};

export const MAP_IMPORT_JOB_STATUS_TO_LABEL = {
  NOT_STARTED: 'Pending',
  VALIDATING: 'Validating',
  VALIDATED: 'Validated',
  PROCESSING: 'Processing',
  DONE: 'Success',
  FAILED: 'Failure',
};

export const EXPORT_JOB_STATUS = {
  notStarted: 'NOT_STARTED',
  processing: 'PROCESSING',
  done: 'DONE',
  failed: 'FAILED',
};

export const EXPORT_JOB_STATUS_TO_LABEL = {
  NOT_STARTED: 'Pending',
  PROCESSING: 'Processing',
  DONE: 'Success',
  FAILED: 'Failure',
};

export const MAP_CONTACT_FIELD_TO_LABEL = {
  email: 'Email',
  first_name: 'First name',
  last_name: 'Last name',
  address_line_1: 'Address line 1',
  address_line_2: 'Address line 2',
  city: 'City',
  state_province_region: 'State/Province/Region',
  country: 'Country',
  postal_code: 'Postal code',
  phone_number: 'Phone number',
};

export const MAP_CONTACT_FIELD_TO_TAG_NAME = {
  email: 'Email',
  first_name: 'FirstName',
  last_name: 'LastName',
  address_line_1: 'AddressLine1',
  address_line_2: 'AddressLine2',
  city: 'City',
  state_province_region: 'StateProvinceRegion',
  country: 'Country',
  postal_code: 'PostalCode',
  phone_number: 'PhoneNumber',
};

// Only for merge tags - not all account info fields included
export const ACCOUNT_INFO_FIELDS = [
  'organizationName',
  'legalName',
  'customerSupportEmail',
  'websiteUrl',
  'legalAddress',
];

export const MAP_ACCOUNT_INFO_TO_LABEL = {
  organizationName: 'Organization name',
  legalName: 'Legal name',
  customerSupportEmail: 'Customer support email',
  websiteUrl: 'Website Url',
  legalAddress: 'Legal address',
};

export const MAP_ACCOUNT_INFO_TO_TAG_NAME = {
  organizationName: 'OrganizationName',
  legalName: 'LegalName',
  customerSupportEmail: 'CustomerSupportEmail',
  websiteUrl: 'WebsiteUrl',
  legalAddress: 'LegalAddress',
};

export const MAP_TAG_NAME_TO_ACCOUNT_INFO = {
  OrganizationName: 'organizationName',
  LegalName: 'legalName',
  CustomerSupportEmail: 'customerSupportEmail',
  WebsiteUrl: 'websiteUrl',
  LegalAddress: 'legalAddress',
};

export const TRANSACTIONAL_EMAILS = {
  oneTimeReceipt: 'oneTimeReceipt',
  oneTimeFailed: 'oneTimeFailed',
  recurringReceipt: 'recurringReceipt',
  recurringInstallmentReceipt: 'recurringInstallmentReceipt',
  recurringInstallmentFailed: 'recurringInstallmentFailed',
  recurringInstallmentCancelled: 'recurringInstallmentCancelled',
  abandonedCart: 'abandonedCart',
  tribute: 'tribute',
  annualDonationsReceipt: 'annualDonationsReceipt',
};

export const MAP_TRANSACTIONAL_EMAILS_TO_FILE_NAME = {
  oneTimeReceipt: 'one-time-receipt.html',
  oneTimeFailed: 'one-time-failed.html',
  recurringReceipt: 'recurring-receipt.html',
  recurringInstallmentReceipt: 'recurring-installment-receipt.html',
  recurringInstallmentFailed: 'recurring-installment-failed.html',
  recurringInstallmentCancelled: 'recurring-installment-cancelled.html',
  abandonedCart: 'abandoned-cart.html',
  tribute: 'tribute.html',
  annualDonationsReceipt: 'annual-donations-receipt.html',
};

export const MAP_TRANSACTIONAL_TEMPLATE_NAME_TO_KEY = {
  'one-time-receipt': 'oneTimeReceipt',
  'one-time-failed': 'oneTimeFailed',
  'recurring-receipt': 'recurringReceipt',
  'recurring-installment-receipt': 'recurringInstallmentReceipt',
  'recurring-installment-failed': 'recurringInstallmentFailed',
  'recurring-installment-cancelled': 'recurringInstallmentCancelled',
  'abandoned-cart': 'abandonedCart',
  tribute: 'tribute',
  'annual-donations-receipt': 'annualDonationsReceipt',
};

export const MAP_TRANSACTIONAL_EMAILS_TO_TEMPLATE_NAME = {
  oneTimeReceipt: 'one-time-receipt',
  oneTimeFailed: 'one-time-failed',
  recurringReceipt: 'recurring-receipt',
  recurringInstallmentReceipt: 'recurring-installment-receipt',
  recurringInstallmentFailed: 'recurring-installment-failed',
  recurringInstallmentCancelled: 'recurring-installment-cancelled',
  abandonedCart: 'abandoned-cart',
  tribute: 'tribute',
  annualDonationsReceipt: 'annual-donations-receipt',
};

export const AUTH_SESSION_KEY = 'id-token';

export const AI_CONTENT_TONES = [
  { label: 'Professional', value: 'professional' },
  { label: 'Informal', value: 'informal' },
  { label: 'Urgent', value: 'urgent' },
  { label: 'Somber', value: 'somber' },
  { label: 'Funny', value: 'funny' },
];

export const MISSION_GEOGRAPHIC_FOCUS = [
  { label: '', value: '' },
  { label: 'Local', value: 'local' },
  { label: 'Metro Area', value: 'metro-area' },
  { label: 'Statewide', value: 'statewide' },
  { label: 'Regional', value: 'regional' },
  { label: 'National', value: 'national' },
  { label: 'Global', value: 'global' },
];

export const ONBOARDING_STEPS = {
  subscription: 0,
  welcome: 1,
  invoices: 2,
  accountInfo: 3,
  organizationProfile: 4,
  stripeAccount: 5,
  donationPage: 6,
  domainAuthentication: 7,
  importContacts: 8,
  emailSettings: 9,
  welcomeSeries: 10,
  contentCalendar: 11,
  scheduleCall: 12,
  congrats: 13,
  completed: 14,
};

export const FILE_STATUS = {
  pending: 'pending',
  saved: 'saved',
  failed: 'failed',
};

export const DEFAULT_HEADER_IMG_BASE64 =
  'data:image/png;base64,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';

export const DEFAULT_HERO_IMG_BASE64 =
  'data:image/png;base64,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';

export const TABLE_PAGE_SIZE_OPTIONS = [
  { label: '5/page', value: 5 },
  { label: '10/page', value: 10 },
  { label: '25/page', value: 25 },
];

export const AMOUNT_CATEGORIES = {
  fifty: '$50',
  oneHundred: '$100',
  fiveHundred: '$500',
  oneThousand: '$1K',
  fiveThousandPlus: '$5K+',
};

export const AMOUNT_CATEGORIES_INTERVAL = {
  $50: '$0 - $50',
  $100: '$51 - $100',
  $500: '$101 - $500',
  $1K: '$501 - $1K',
  '$5K+': '$1K+ - $5K+',
};

export const TREND_DIRECTIONS = {
  up: 'up',
  down: 'down',
  equal: 'equal',
};

export const CAMPAIGNS_VIEW_MODES = {
  table: 'table',
  calendar: 'calendar',
};

export const EMAIL_BUTTON_KEY_NAMES = {
  shareMissionButton: 'shareMissionButton',
  subscribeButton: 'subscribeButton',
};

export const EMAIL_BUTTON_KEY_NAME_TO_LABEL = {
  [EMAIL_BUTTON_KEY_NAMES.shareMissionButton]: 'Share our mission',
  [EMAIL_BUTTON_KEY_NAMES.subscribeButton]: 'Subscribe',
};

export const EMAIL_SECTION_KEY_NAMES = {
  header: 'header',
  footer: 'footer',
};

export const EMAIL_SECTION_KEY_NAME_TO_SUBTITLE = {
  [EMAIL_SECTION_KEY_NAMES.header]:
    'Your organization logo, a larger email hero image, or anything else you want recipients to first see when opening your email',
  [EMAIL_SECTION_KEY_NAMES.footer]: 'A signature, sign off, Donate button, or other call to action',
};

export const IMPORT_TYPES = {
  contacts: 'contacts',
  suppressionList: 'suppression_list',
};

/**
 * Mapping target that marks a CSV column as the tags column.
 *
 * A sentinel rather than plain 'tags' so that mapping a column to Tags always
 * resolves to the reserved field even for a tenant who owns a custom field called
 * "Tags". MUST match TAGS_FIELD_MAPPING_TARGET in
 * backend/contacts-api/shared/utils.js.
 */
export const TAGS_FIELD_MAPPING_TARGET = '__tags__';

/**
 * The three reserved donor buckets, seeded per tenant by onboarding-api.
 *
 * MUST match the names in RESERVED_DONOR_TAGS in
 * backend/onboarding-api/lib/constants/index.ts — the onboarding cards resolve the
 * tags by name, and nothing enforces that these two lists agree.
 */
export const RESERVED_DONOR_TAG_NAMES = ['Active donors', 'Lapsed donors', 'Never donors'];

/**
 * Separator for multiple tags in one CSV cell. Semicolon, not comma: a tag name
 * may legitimately contain a comma. MUST match TAG_VALUE_DELIMITER in
 * backend/contacts-api/shared/utils.js.
 */
export const TAG_VALUE_DELIMITER = ';';

/** Matches the cap enforced by lists-api's create endpoint. */
export const TAG_DESCRIPTION_MAX_LENGTH = 500;

export const MFA_SETTINGS = {
  sms: 'SMS_MFA',
  totp: 'SOFTWARE_TOKEN_MFA',
};

export const MFA_SETTING_LABELS = {
  SMS_MFA: 'SMS',
  SOFTWARE_TOKEN_MFA: 'TOTP',
};

export const USER_STATUS = {
  confirmed: 'CONFIRMED',
  forceChangePassword: 'FORCE_CHANGE_PASSWORD',
};

export const USER_STATUS_TO_LABEL = {
  [USER_STATUS.confirmed]: 'Active',
  [USER_STATUS.forceChangePassword]: 'Must change password',
};

export const USER_ROLES = {
  editor: 'editor-tenant',
  administrator: 'administrator-tenant',
};

export const USER_ROLE_TO_LABEL = {
  [USER_ROLES.editor]: 'Editor',
  [USER_ROLES.administrator]: 'Administrator',
};

export const RECOMMENDED_TASK_TYPES = {
  weeklyCampaignScheduling: 'weekly-campaign-scheduling',
  reviewSuggestedDraft: 'review-suggested-draft',
  reviewPotentialMajorDonors: 'review-potential-major-donors',
  message: 'message',
  monthlyUpdateReminder: 'monthly-update-reminder',
};

// Email notification types managed via notifications-api. One per recommended
// task type; keep values in sync with the backend `NOTIFICATION_TYPES`.
export const NOTIFICATION_TYPES = {
  weeklyCampaignScheduling: 'weekly-campaign-scheduling',
  reviewSuggestedDraft: 'review-suggested-draft',
  message: 'message',
  monthlyUpdateReminder: 'monthly-update-reminder',
  reviewPotentialMajorDonors: 'review-potential-major-donors',
};

export const NOTIFICATION_TYPE_LABELS = {
  [NOTIFICATION_TYPES.weeklyCampaignScheduling]: 'Weekly campaign scheduling',
  [NOTIFICATION_TYPES.reviewSuggestedDraft]: 'Review suggested draft',
  [NOTIFICATION_TYPES.message]: 'Messages',
  [NOTIFICATION_TYPES.monthlyUpdateReminder]: 'Monthly update reminder',
  [NOTIFICATION_TYPES.reviewPotentialMajorDonors]: 'Review potential major donors',
};

export const NOTIFICATION_TYPE_DESCRIPTIONS = {
  [NOTIFICATION_TYPES.weeklyCampaignScheduling]: 'When it’s time to schedule campaigns for an upcoming week.',
  [NOTIFICATION_TYPES.reviewSuggestedDraft]: 'When a suggested draft is ready to review.',
  [NOTIFICATION_TYPES.message]: 'Direct messages from the DonorSpring team.',
  [NOTIFICATION_TYPES.monthlyUpdateReminder]: 'A monthly reminder to submit your update.',
  [NOTIFICATION_TYPES.reviewPotentialMajorDonors]: 'When new potential major donors are ready to review.',
};

// Order in which notification types are displayed in settings.
export const NOTIFICATION_TYPE_ORDER = [
  NOTIFICATION_TYPES.weeklyCampaignScheduling,
  NOTIFICATION_TYPES.reviewSuggestedDraft,
  NOTIFICATION_TYPES.monthlyUpdateReminder,
  NOTIFICATION_TYPES.reviewPotentialMajorDonors,
  NOTIFICATION_TYPES.message,
];

export const RECOMMENDED_TASK_ACTIONS = {
  reviewDraft: 'Review Draft',
  scheduleCampaign: 'Schedule Campaign',
  reviewMajorDonors: 'Review Major Donors',
  viewMessage: 'View Message',
  submitUpdate: 'Submit Update',
};

export const RECOMMENDED_TASK_STATUS = {
  pending: 'pending',
  completed: 'completed',
  expired: 'expired',
};

export const RECOMMENDED_TASK_STATUS_LABELS = {
  [RECOMMENDED_TASK_STATUS.pending]: 'Pending',
  [RECOMMENDED_TASK_STATUS.completed]: 'Complete',
  [RECOMMENDED_TASK_STATUS.expired]: 'Expired',
};

export const RECOMMENDED_TASK_SORT_BY = {
  name: 'description',
  status: 'status',
  expirationTimestamp: 'expirationTimestamp',
};

export const RECOMMENDED_TASK_SORT_BY_LABELS = {
  [RECOMMENDED_TASK_SORT_BY.name]: 'Name',
  [RECOMMENDED_TASK_SORT_BY.status]: 'Status',
  [RECOMMENDED_TASK_SORT_BY.expirationTimestamp]: 'Expires At',
};

export const CONTACT_ACTIONS = {
  view: 'View',
  edit: 'Edit',
};

export const CONTACT_STATUS_LABELS = {
  subscribed: 'Subscribed',
  unsubscribed: 'Unsubscribed',
  archived: 'Archived',
};

export const DONATION_ACTIONS = {
  viewContact: 'View Contact',
  refund: 'Refund Donation',
  resendReceipt: 'Resend Receipt Email',
  cancelSubscription: 'Cancel Subscription',
};

export const EXPORT_FILENAME_REGEX = /^[a-zA-Z0-9!\-_*'().]+$/;

export const INVALID_EXPORT_FILENAME_MESSAGE =
  "Export name must only contain letters, numbers, and the following special characters: exclamation point (!), hyphen (-), underscore (_), period (.), asterisk (*), single quote ('), open parenthesis ((), and close parenthesis ()).";

export const DONATIONS_SORT_BY = {
  createdAt: 'createdAt',
  netAmount: 'netAmount',
};

export const EXPORT_JOB_TYPES = {
  donations: 'donations',
  contacts: 'contacts',
};

export const EXPORT_JOB_TYPE_LABELS = {
  [EXPORT_JOB_TYPES.donations]: 'Donations',
  [EXPORT_JOB_TYPES.contacts]: 'Contacts',
};

export const INVOICE_STATUS = {
  draft: 'draft',
  open: 'open',
  paid: 'paid',
  void: 'void',
  uncollectible: 'uncollectible',
};

export const STATUS_STATES = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error',
};

export const PAGES_IMAGE_KEYS = {
  headerImage: 'headerImage',
  heroImage: 'heroImage',
  faviconImage: 'faviconImage',
};

export const IMAGE_KEYS_WITH_DEFAULT_BASE64_DATA = [PAGES_IMAGE_KEYS.headerImage, PAGES_IMAGE_KEYS.heroImage];

export const INTEGRATION_FEATURES = {
  pushNewDonations: 'push-new-donations',
  pullNewContacts: 'pull-new-contacts',
  pushNewContacts: 'push-new-contacts',
  socialMediaPost: 'social-media-post',
};

export const INTEGRATION_TYPES = {
  zapier: 'zapier',
  facebook: 'facebook',
  linkedIn: 'linkedIn',
  doubleTheDonation: 'doubleTheDonation',
};

export const SOCIAL_INTEGRATION_TYPES = [INTEGRATION_TYPES.facebook, INTEGRATION_TYPES.linkedIn];

export const INTEGRATION_TYPE_LABELS = {
  [INTEGRATION_TYPES.zapier]: 'Zapier',
  [INTEGRATION_TYPES.facebook]: 'Facebook',
  [INTEGRATION_TYPES.linkedIn]: 'LinkedIn',
  [INTEGRATION_TYPES.doubleTheDonation]: 'Double the Donation',
};
